<div class="row align-items-center">
  <div class="col-auto pe-1">
    <app-avatar
      [firstName]="item().holder.first_name"
      [lastName]="item().holder.last_name"
      [size]="'md'"></app-avatar>
  </div>
  <div class="col-auto">
    @if (item().type === CardType.Personal) {
      <div class="title">{{ item().holder.first_name }} {{ item().holder.last_name }}</div>
      <div class="text-sm">
        <span class="badge text-body bg-gray">{{ item().masked_number | slice: 8 : 16 | emptyIndicator }}</span>
        /
        <span class="badge text-info bg-info">Employee</span>
      </div>
    } @else {
      <div class="title">{{ item().name }}</div>
      <div class="text-sm">
        <span class="badge text-body bg-gray">{{ item().masked_number | slice: 8 : 16 | emptyIndicator }}</span>
        /
        <span class="badge text-body bg-gray">{{ item().holder.first_name }} {{ item().holder.last_name }}</span>
        /
        <span class="badge text-success bg-success">Subscription</span>
      </div>
    }
  </div>
  @if (isRecurring() && item().recurring_rule_id) {
    <div
      class="col-auto ms-auto"
      title="Card has a recurring rule">
      <i class="pays-svg-icon ic-card-plus"></i>
    </div>
  }
</div>
